import { render, staticRenderFns } from "./index.vue?vue&type=template&id=438f3ef2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438f3ef2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('438f3ef2')) {
      api.createRecord('438f3ef2', component.options)
    } else {
      api.reload('438f3ef2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=438f3ef2&scoped=true&", function () {
      api.rerender('438f3ef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/chat_helper/index.vue"
export default component.exports